export class EmailEditDialogModel {
    type: string;
    emails: string[];
  }